type IconProps = React.HTMLAttributes<SVGElement>;

export const IllustrationHubName = (props: IconProps) => {
	return (
		<svg width="342" height="254" viewBox="0 0 342 254" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<rect x="0.5" y="22" width="341" height="17" fill="white" stroke="#31323A" />
			<path d="M340.941 39.75L333.941 43.25H8.05859L1.05859 39.75H340.941Z" fill="#31323A" stroke="#31323A" stroke-width="0.5" />
			<rect x="8.5" y="44" width="325" height="209" fill="white" />
			<rect x="8.5" y="44" width="325" height="209" stroke="#31323A" />
			<mask id="path-4-inside-1_140_23513" fill="white">
				<path d="M16 51.5H78V87.5H16V51.5Z" />
			</mask>
			<path d="M16 51.5H78V87.5H16V51.5Z" fill="white" />
			<path
				d="M16 51.5V51H15.5V51.5H16ZM16 51.5V52H78V51.5V51H16V51.5ZM16 87.5H16.5V51.5H16H15.5V87.5H16Z"
				fill="#31323A"
				mask="url(#path-4-inside-1_140_23513)"
			/>
			<mask id="path-6-inside-2_140_23513" fill="white">
				<path d="M78 51.5H140V87.5H78V51.5Z" />
			</mask>
			<path d="M78 51.5H140V87.5H78V51.5Z" fill="white" />
			<path
				d="M78 51.5V51H77.5V51.5H78ZM78 51.5V52H140V51.5V51H78V51.5ZM78 87.5H78.5V51.5H78H77.5V87.5H78Z"
				fill="#31323A"
				mask="url(#path-6-inside-2_140_23513)"
			/>
			<mask id="path-8-inside-3_140_23513" fill="white">
				<path d="M140 51.5H202V87.5H140V51.5Z" />
			</mask>
			<path d="M140 51.5H202V87.5H140V51.5Z" fill="white" />
			<path
				d="M140 51.5V51H139.5V51.5H140ZM140 51.5V52H202V51.5V51H140V51.5ZM140 87.5H140.5V51.5H140H139.5V87.5H140Z"
				fill="#31323A"
				mask="url(#path-8-inside-3_140_23513)"
			/>
			<mask id="path-10-inside-4_140_23513" fill="white">
				<path d="M202 51.5H264V87.5H202V51.5Z" />
			</mask>
			<path
				d="M202 51.5V51H201.5V51.5H202ZM202 51.5V52H264V51.5V51H202V51.5ZM202 87.5H202.5V51.5H202H201.5V87.5H202Z"
				fill="#31323A"
				mask="url(#path-10-inside-4_140_23513)"
			/>
			<mask id="path-12-inside-5_140_23513" fill="white">
				<path d="M264 51.5H326V87.5H264V51.5Z" />
			</mask>
			<path d="M264 51.5H326V87.5H264V51.5Z" fill="white" />
			<path
				d="M264 51.5V51H263.5V51.5H264ZM326 51.5H326.5V51H326V51.5ZM264 51.5V52H326V51.5V51H264V51.5ZM326 51.5H325.5V87.5H326H326.5V51.5H326ZM264 87.5H264.5V51.5H264H263.5V87.5H264Z"
				fill="#31323A"
				mask="url(#path-12-inside-5_140_23513)"
			/>
			<rect width="310" height="20" transform="translate(16 87.5)" fill="white" />
			<mask id="path-14-inside-6_140_23513" fill="white">
				<path d="M16 87.5H78V107.5H16V87.5Z" />
			</mask>
			<path d="M16 87.5H78V107.5H16V87.5Z" fill="white" />
			<path
				d="M16 87.5V87H15.5V87.5H16ZM16 87.5V88H78V87.5V87H16V87.5ZM16 107.5H16.5V87.5H16H15.5V107.5H16Z"
				fill="#31323A"
				mask="url(#path-14-inside-6_140_23513)"
			/>
			<rect width="62" height="20" transform="translate(78 87.5)" fill="white" />
			<mask id="path-16-inside-7_140_23513" fill="white">
				<path d="M78 87.5H140V97.5H78V87.5Z" />
			</mask>
			<path d="M78 87.5H140V97.5H78V87.5Z" fill="white" />
			<path
				d="M78 87.5V87H77.5V87.5H78ZM78 87.5V88H140V87.5V87H78V87.5ZM78 97.5H78.5V87.5H78H77.5V97.5H78Z"
				fill="#31323A"
				mask="url(#path-16-inside-7_140_23513)"
			/>
			<mask id="path-18-inside-8_140_23513" fill="white">
				<path d="M78 97.5H140V107.5H78V97.5Z" />
			</mask>
			<path d="M78 97.5H140V107.5H78V97.5Z" fill="white" />
			<path
				d="M78 97.5V97H77.5V97.5H78ZM78 97.5V98H140V97.5V97H78V97.5ZM78 107.5H78.5V97.5H78H77.5V107.5H78Z"
				fill="#31323A"
				mask="url(#path-18-inside-8_140_23513)"
			/>
			<rect width="62" height="20" transform="translate(140 87.5)" fill="white" />
			<mask id="path-20-inside-9_140_23513" fill="white">
				<path d="M140 87.5H202V97.5H140V87.5Z" />
			</mask>
			<path d="M140 87.5H202V97.5H140V87.5Z" fill="white" />
			<path
				d="M140 87.5V87H139.5V87.5H140ZM140 87.5V88H202V87.5V87H140V87.5ZM140 97.5H140.5V87.5H140H139.5V97.5H140Z"
				fill="#31323A"
				mask="url(#path-20-inside-9_140_23513)"
			/>
			<mask id="path-22-inside-10_140_23513" fill="white">
				<path d="M140 97.5H202V107.5H140V97.5Z" />
			</mask>
			<path d="M140 97.5H202V107.5H140V97.5Z" fill="white" />
			<path
				d="M140 97.5V97H139.5V97.5H140ZM140 97.5V98H202V97.5V97H140V97.5ZM140 107.5H140.5V97.5H140H139.5V107.5H140Z"
				fill="#31323A"
				mask="url(#path-22-inside-10_140_23513)"
			/>
			<rect width="62" height="20" transform="translate(202 87.5)" fill="white" />
			<mask id="path-24-inside-11_140_23513" fill="white">
				<path d="M202 87.5H264V97.5H202V87.5Z" />
			</mask>
			<path
				d="M202 87.5V87H201.5V87.5H202ZM202 87.5V88H264V87.5V87H202V87.5ZM202 97.5H202.5V87.5H202H201.5V97.5H202Z"
				fill="#31323A"
				mask="url(#path-24-inside-11_140_23513)"
			/>
			<path
				d="M202 87.5V87H201.5V87.5H202ZM202 87.5V88H264V87.5V87H202V87.5ZM202 97.5H202.5V87.5H202H201.5V97.5H202Z"
				fill="black"
				fill-opacity="0.2"
				mask="url(#path-24-inside-11_140_23513)"
			/>
			<mask id="path-26-inside-12_140_23513" fill="white">
				<path d="M202 97.5H264V107.5H202V97.5Z" />
			</mask>
			<path
				d="M202 97.5V97H201.5V97.5H202ZM202 97.5V98H264V97.5V97H202V97.5ZM202 107.5H202.5V97.5H202H201.5V107.5H202Z"
				fill="#31323A"
				mask="url(#path-26-inside-12_140_23513)"
			/>
			<mask id="path-28-inside-13_140_23513" fill="white">
				<path d="M264 87.5H326V107.5H264V87.5Z" />
			</mask>
			<path d="M264 87.5H326V107.5H264V87.5Z" fill="white" />
			<path
				d="M264 87.5V87H263.5V87.5H264ZM326 87.5H326.5V87H326V87.5ZM264 87.5V88H326V87.5V87H264V87.5ZM326 87.5H325.5V107.5H326H326.5V87.5H326ZM264 107.5H264.5V87.5H264H263.5V107.5H264Z"
				fill="#31323A"
				mask="url(#path-28-inside-13_140_23513)"
			/>
			<rect width="310" height="20" transform="translate(16 107.5)" fill="white" />
			<mask id="path-30-inside-14_140_23513" fill="white">
				<path d="M16 107.5H78V127.5H16V107.5Z" />
			</mask>
			<path d="M16 107.5H78V127.5H16V107.5Z" fill="white" />
			<path
				d="M16 107.5V107H15.5V107.5H16ZM16 107.5V108H78V107.5V107H16V107.5ZM16 127.5H16.5V107.5H16H15.5V127.5H16Z"
				fill="#31323A"
				mask="url(#path-30-inside-14_140_23513)"
			/>
			<mask id="path-32-inside-15_140_23513" fill="white">
				<path d="M78 107.5H140V127.5H78V107.5Z" />
			</mask>
			<path d="M78 107.5H140V127.5H78V107.5Z" fill="white" />
			<path
				d="M78 107.5V107H77.5V107.5H78ZM78 107.5V108H140V107.5V107H78V107.5ZM78 127.5H78.5V107.5H78H77.5V127.5H78Z"
				fill="#31323A"
				mask="url(#path-32-inside-15_140_23513)"
			/>
			<mask id="path-34-inside-16_140_23513" fill="white">
				<path d="M140 107.5H202V127.5H140V107.5Z" />
			</mask>
			<path d="M140 107.5H202V127.5H140V107.5Z" fill="white" />
			<path
				d="M140 107.5V107H139.5V107.5H140ZM140 107.5V108H202V107.5V107H140V107.5ZM140 127.5H140.5V107.5H140H139.5V127.5H140Z"
				fill="#31323A"
				mask="url(#path-34-inside-16_140_23513)"
			/>
			<mask id="path-36-inside-17_140_23513" fill="white">
				<path d="M202 107.5H264V127.5H202V107.5Z" />
			</mask>
			<path
				d="M202 107.5V107H201.5V107.5H202ZM202 107.5V108H264V107.5V107H202V107.5ZM202 127.5H202.5V107.5H202H201.5V127.5H202Z"
				fill="#31323A"
				mask="url(#path-36-inside-17_140_23513)"
			/>
			<mask id="path-38-inside-18_140_23513" fill="white">
				<path d="M264 107.5H326V127.5H264V107.5Z" />
			</mask>
			<path d="M264 107.5H326V127.5H264V107.5Z" fill="white" />
			<path
				d="M264 107.5V107H263.5V107.5H264ZM326 107.5H326.5V107H326V107.5ZM264 107.5V108H326V107.5V107H264V107.5ZM326 107.5H325.5V127.5H326H326.5V107.5H326ZM264 127.5H264.5V107.5H264H263.5V127.5H264Z"
				fill="#31323A"
				mask="url(#path-38-inside-18_140_23513)"
			/>
			<rect width="310" height="60" transform="translate(16 127.5)" fill="white" />
			<mask id="path-40-inside-19_140_23513" fill="white">
				<path d="M16 127.5H78V137.5H16V127.5Z" />
			</mask>
			<path d="M16 127.5H78V137.5H16V127.5Z" fill="white" />
			<path
				d="M16 127.5V127H15.5V127.5H16ZM16 127.5V128H78V127.5V127H16V127.5ZM16 137.5H16.5V127.5H16H15.5V137.5H16Z"
				fill="#31323A"
				mask="url(#path-40-inside-19_140_23513)"
			/>
			<mask id="path-42-inside-20_140_23513" fill="white">
				<path d="M16 137.5H78V147.5H16V137.5Z" />
			</mask>
			<path d="M16 137.5H78V147.5H16V137.5Z" fill="white" />
			<path
				d="M16 137.5V137H15.5V137.5H16ZM16 137.5V138H78V137.5V137H16V137.5ZM16 147.5H16.5V137.5H16H15.5V147.5H16Z"
				fill="#31323A"
				mask="url(#path-42-inside-20_140_23513)"
			/>
			<mask id="path-44-inside-21_140_23513" fill="white">
				<path d="M78 127.5H140V137.5H78V127.5Z" />
			</mask>
			<path d="M78 127.5H140V137.5H78V127.5Z" fill="white" />
			<path
				d="M78 127.5V127H77.5V127.5H78ZM78 127.5V128H140V127.5V127H78V127.5ZM78 137.5H78.5V127.5H78H77.5V137.5H78Z"
				fill="#31323A"
				mask="url(#path-44-inside-21_140_23513)"
			/>
			<mask id="path-46-inside-22_140_23513" fill="white">
				<path d="M78 137.5H140V147.5H78V137.5Z" />
			</mask>
			<path d="M78 137.5H140V147.5H78V137.5Z" fill="white" />
			<path
				d="M78 137.5V137H77.5V137.5H78ZM78 137.5V138H140V137.5V137H78V137.5ZM78 147.5H78.5V137.5H78H77.5V147.5H78Z"
				fill="#31323A"
				mask="url(#path-46-inside-22_140_23513)"
			/>
			<mask id="path-48-inside-23_140_23513" fill="white">
				<path d="M16 147.5H78V167.5H16V147.5Z" />
			</mask>
			<path d="M16 147.5H78V167.5H16V147.5Z" fill="white" />
			<path
				d="M16 147.5V147H15.5V147.5H16ZM16 147.5V148H78V147.5V147H16V147.5ZM16 167.5H16.5V147.5H16H15.5V167.5H16Z"
				fill="#31323A"
				mask="url(#path-48-inside-23_140_23513)"
			/>
			<mask id="path-50-inside-24_140_23513" fill="white">
				<path d="M78 147.5H140V167.5H78V147.5Z" />
			</mask>
			<path d="M78 147.5H140V167.5H78V147.5Z" fill="white" />
			<path
				d="M78 147.5V147H77.5V147.5H78ZM78 147.5V148H140V147.5V147H78V147.5ZM78 167.5H78.5V147.5H78H77.5V167.5H78Z"
				fill="#31323A"
				mask="url(#path-50-inside-24_140_23513)"
			/>
			<mask id="path-52-inside-25_140_23513" fill="white">
				<path d="M16 167.5H78V177.5H16V167.5Z" />
			</mask>
			<path d="M16 167.5H78V177.5H16V167.5Z" fill="white" />
			<path
				d="M16 167.5V167H15.5V167.5H16ZM16 167.5V168H78V167.5V167H16V167.5ZM16 177.5H16.5V167.5H16H15.5V177.5H16Z"
				fill="#31323A"
				mask="url(#path-52-inside-25_140_23513)"
			/>
			<mask id="path-54-inside-26_140_23513" fill="white">
				<path d="M16 177.5H78V187.5H16V177.5Z" />
			</mask>
			<path d="M16 177.5H78V187.5H16V177.5Z" fill="white" />
			<path
				d="M16 177.5V177H15.5V177.5H16ZM16 177.5V178H78V177.5V177H16V177.5ZM16 187.5H16.5V177.5H16H15.5V187.5H16Z"
				fill="#31323A"
				mask="url(#path-54-inside-26_140_23513)"
			/>
			<mask id="path-56-inside-27_140_23513" fill="white">
				<path d="M78 167.5H140V177.5H78V167.5Z" />
			</mask>
			<path d="M78 167.5H140V177.5H78V167.5Z" fill="white" />
			<path
				d="M78 167.5V167H77.5V167.5H78ZM78 167.5V168H140V167.5V167H78V167.5ZM78 177.5H78.5V167.5H78H77.5V177.5H78Z"
				fill="#31323A"
				mask="url(#path-56-inside-27_140_23513)"
			/>
			<mask id="path-58-inside-28_140_23513" fill="white">
				<path d="M78 177.5H140V187.5H78V177.5Z" />
			</mask>
			<path d="M78 177.5H140V187.5H78V177.5Z" fill="white" />
			<path
				d="M78 177.5V177H77.5V177.5H78ZM78 177.5V178H140V177.5V177H78V177.5ZM78 187.5H78.5V177.5H78H77.5V187.5H78Z"
				fill="#31323A"
				mask="url(#path-58-inside-28_140_23513)"
			/>
			<mask id="path-60-inside-29_140_23513" fill="white">
				<path d="M140 127.5H202V187.5H140V127.5Z" />
			</mask>
			<path d="M140 127.5H202V187.5H140V127.5Z" fill="white" />
			<path
				d="M140 127.5V127H139.5V127.5H140ZM140 127.5V128H202V127.5V127H140V127.5ZM140 187.5H140.5V127.5H140H139.5V187.5H140Z"
				fill="#31323A"
				mask="url(#path-60-inside-29_140_23513)"
			/>
			<mask id="path-62-inside-30_140_23513" fill="white">
				<path d="M202 127.5H264V137.5H202V127.5Z" />
			</mask>
			<path
				d="M202 127.5V127H201.5V127.5H202ZM202 127.5V128H264V127.5V127H202V127.5ZM202 137.5H202.5V127.5H202H201.5V137.5H202Z"
				fill="#31323A"
				mask="url(#path-62-inside-30_140_23513)"
			/>
			<mask id="path-64-inside-31_140_23513" fill="white">
				<path d="M202 137.5H264V147.5H202V137.5Z" />
			</mask>
			<path
				d="M202 137.5V137H201.5V137.5H202ZM202 137.5V138H264V137.5V137H202V137.5ZM202 147.5H202.5V137.5H202H201.5V147.5H202Z"
				fill="#31323A"
				mask="url(#path-64-inside-31_140_23513)"
			/>
			<mask id="path-66-inside-32_140_23513" fill="white">
				<path d="M264 127.5H326V137.5H264V127.5Z" />
			</mask>
			<path d="M264 127.5H326V137.5H264V127.5Z" fill="white" />
			<path
				d="M264 127.5V127H263.5V127.5H264ZM326 127.5H326.5V127H326V127.5ZM264 127.5V128H326V127.5V127H264V127.5ZM326 127.5H325.5V137.5H326H326.5V127.5H326ZM264 137.5H264.5V127.5H264H263.5V137.5H264Z"
				fill="#31323A"
				mask="url(#path-66-inside-32_140_23513)"
			/>
			<mask id="path-68-inside-33_140_23513" fill="white">
				<path d="M264 137.5H326V147.5H264V137.5Z" />
			</mask>
			<path d="M264 137.5H326V147.5H264V137.5Z" fill="white" />
			<path
				d="M264 137.5V137H263.5V137.5H264ZM326 137.5H326.5V137H326V137.5ZM264 137.5V138H326V137.5V137H264V137.5ZM326 137.5H325.5V147.5H326H326.5V137.5H326ZM264 147.5H264.5V137.5H264H263.5V147.5H264Z"
				fill="#31323A"
				mask="url(#path-68-inside-33_140_23513)"
			/>
			<mask id="path-70-inside-34_140_23513" fill="white">
				<path d="M202 147.5H264V167.5H202V147.5Z" />
			</mask>
			<path
				d="M202 147.5V147H201.5V147.5H202ZM202 147.5V148H264V147.5V147H202V147.5ZM202 167.5H202.5V147.5H202H201.5V167.5H202Z"
				fill="#31323A"
				mask="url(#path-70-inside-34_140_23513)"
			/>
			<mask id="path-72-inside-35_140_23513" fill="white">
				<path d="M264 147.5H326V167.5H264V147.5Z" />
			</mask>
			<path d="M264 147.5H326V167.5H264V147.5Z" fill="white" />
			<path
				d="M264 147.5V147H263.5V147.5H264ZM326 147.5H326.5V147H326V147.5ZM264 147.5V148H326V147.5V147H264V147.5ZM326 147.5H325.5V167.5H326H326.5V147.5H326ZM264 167.5H264.5V147.5H264H263.5V167.5H264Z"
				fill="#31323A"
				mask="url(#path-72-inside-35_140_23513)"
			/>
			<mask id="path-74-inside-36_140_23513" fill="white">
				<path d="M202 167.5H264V177.5H202V167.5Z" />
			</mask>
			<path
				d="M202 167.5V167H201.5V167.5H202ZM202 167.5V168H264V167.5V167H202V167.5ZM202 177.5H202.5V167.5H202H201.5V177.5H202Z"
				fill="#31323A"
				mask="url(#path-74-inside-36_140_23513)"
			/>
			<mask id="path-76-inside-37_140_23513" fill="white">
				<path d="M202 177.5H264V187.5H202V177.5Z" />
			</mask>
			<path
				d="M202 177.5V177H201.5V177.5H202ZM202 177.5V178H264V177.5V177H202V177.5ZM202 187.5H202.5V177.5H202H201.5V187.5H202Z"
				fill="#31323A"
				mask="url(#path-76-inside-37_140_23513)"
			/>
			<mask id="path-78-inside-38_140_23513" fill="white">
				<path d="M264 167.5H326V177.5H264V167.5Z" />
			</mask>
			<path d="M264 167.5H326V177.5H264V167.5Z" fill="white" />
			<path
				d="M264 167.5V167H263.5V167.5H264ZM326 167.5H326.5V167H326V167.5ZM264 167.5V168H326V167.5V167H264V167.5ZM326 167.5H325.5V177.5H326H326.5V167.5H326ZM264 177.5H264.5V167.5H264H263.5V177.5H264Z"
				fill="#31323A"
				mask="url(#path-78-inside-38_140_23513)"
			/>
			<mask id="path-80-inside-39_140_23513" fill="white">
				<path d="M264 177.5H326V187.5H264V177.5Z" />
			</mask>
			<path d="M264 177.5H326V187.5H264V177.5Z" fill="white" />
			<path
				d="M264 177.5V177H263.5V177.5H264ZM326 177.5H326.5V177H326V177.5ZM264 177.5V178H326V177.5V177H264V177.5ZM326 177.5H325.5V187.5H326H326.5V177.5H326ZM264 187.5H264.5V177.5H264H263.5V187.5H264Z"
				fill="#31323A"
				mask="url(#path-80-inside-39_140_23513)"
			/>
			<mask id="path-82-inside-40_140_23513" fill="white">
				<path d="M16 187.5H78V197.5H16V187.5Z" />
			</mask>
			<path d="M16 187.5H78V197.5H16V187.5Z" fill="white" />
			<path
				d="M16 187.5V187H15.5V187.5H16ZM16 187.5V188H78V187.5V187H16V187.5ZM16 197.5H16.5V187.5H16H15.5V197.5H16Z"
				fill="#31323A"
				mask="url(#path-82-inside-40_140_23513)"
			/>
			<mask id="path-84-inside-41_140_23513" fill="white">
				<path d="M16 197.5H78V207.5H16V197.5Z" />
			</mask>
			<path d="M16 197.5H78V207.5H16V197.5Z" fill="white" />
			<path
				d="M16 197.5V197H15.5V197.5H16ZM16 197.5V198H78V197.5V197H16V197.5ZM16 207.5H16.5V197.5H16H15.5V207.5H16Z"
				fill="#31323A"
				mask="url(#path-84-inside-41_140_23513)"
			/>
			<mask id="path-86-inside-42_140_23513" fill="white">
				<path d="M78 187.5H140V197.5H78V187.5Z" />
			</mask>
			<path d="M78 187.5H140V197.5H78V187.5Z" fill="white" />
			<path
				d="M78 187.5V187H77.5V187.5H78ZM78 187.5V188H140V187.5V187H78V187.5ZM78 197.5H78.5V187.5H78H77.5V197.5H78Z"
				fill="#31323A"
				mask="url(#path-86-inside-42_140_23513)"
			/>
			<mask id="path-88-inside-43_140_23513" fill="white">
				<path d="M78 197.5H140V207.5H78V197.5Z" />
			</mask>
			<path d="M78 197.5H140V207.5H78V197.5Z" fill="white" />
			<path
				d="M78 197.5V197H77.5V197.5H78ZM78 197.5V198H140V197.5V197H78V197.5ZM78 207.5H78.5V197.5H78H77.5V207.5H78Z"
				fill="#31323A"
				mask="url(#path-88-inside-43_140_23513)"
			/>
			<mask id="path-90-inside-44_140_23513" fill="white">
				<path d="M140 187.5H202V197.5H140V187.5Z" />
			</mask>
			<path d="M140 187.5H202V197.5H140V187.5Z" fill="white" />
			<path
				d="M140 187.5V187H139.5V187.5H140ZM140 187.5V188H202V187.5V187H140V187.5ZM140 197.5H140.5V187.5H140H139.5V197.5H140Z"
				fill="#31323A"
				mask="url(#path-90-inside-44_140_23513)"
			/>
			<mask id="path-92-inside-45_140_23513" fill="white">
				<path d="M140 197.5H202V207.5H140V197.5Z" />
			</mask>
			<path d="M140 197.5H202V207.5H140V197.5Z" fill="white" />
			<path
				d="M140 197.5V197H139.5V197.5H140ZM140 197.5V198H202V197.5V197H140V197.5ZM140 207.5H140.5V197.5H140H139.5V207.5H140Z"
				fill="#31323A"
				mask="url(#path-92-inside-45_140_23513)"
			/>
			<mask id="path-94-inside-46_140_23513" fill="white">
				<path d="M202 187.5H264V197.5H202V187.5Z" />
			</mask>
			<path
				d="M202 187.5V187H201.5V187.5H202ZM202 187.5V188H264V187.5V187H202V187.5ZM202 197.5H202.5V187.5H202H201.5V197.5H202Z"
				fill="#31323A"
				mask="url(#path-94-inside-46_140_23513)"
			/>
			<mask id="path-96-inside-47_140_23513" fill="white">
				<path d="M202 197.5H264V207.5H202V197.5Z" />
			</mask>
			<path
				d="M202 197.5V197H201.5V197.5H202ZM202 197.5V198H264V197.5V197H202V197.5ZM202 207.5H202.5V197.5H202H201.5V207.5H202Z"
				fill="#31323A"
				mask="url(#path-96-inside-47_140_23513)"
			/>
			<mask id="path-98-inside-48_140_23513" fill="white">
				<path d="M264 187.5H326V197.5H264V187.5Z" />
			</mask>
			<path d="M264 187.5H326V197.5H264V187.5Z" fill="white" />
			<path
				d="M264 187.5V187H263.5V187.5H264ZM326 187.5H326.5V187H326V187.5ZM264 187.5V188H326V187.5V187H264V187.5ZM326 187.5H325.5V197.5H326H326.5V187.5H326ZM264 197.5H264.5V187.5H264H263.5V197.5H264Z"
				fill="#31323A"
				mask="url(#path-98-inside-48_140_23513)"
			/>
			<mask id="path-100-inside-49_140_23513" fill="white">
				<path d="M264 197.5H326V207.5H264V197.5Z" />
			</mask>
			<path d="M264 197.5H326V207.5H264V197.5Z" fill="white" />
			<path
				d="M264 197.5V197H263.5V197.5H264ZM326 197.5H326.5V197H326V197.5ZM264 197.5V198H326V197.5V197H264V197.5ZM326 197.5H325.5V207.5H326H326.5V197.5H326ZM264 207.5H264.5V197.5H264H263.5V207.5H264Z"
				fill="#31323A"
				mask="url(#path-100-inside-49_140_23513)"
			/>
			<rect width="310" height="38" transform="translate(16 207.5)" fill="white" />
			<mask id="path-102-inside-50_140_23513" fill="white">
				<path d="M16 207.5H78V245.5H16V207.5Z" />
			</mask>
			<path d="M16 207.5H78V245.5H16V207.5Z" fill="white" />
			<path
				d="M16 207.5V207H15.5V207.5H16ZM16 245.5H15.5V246H16V245.5ZM16 207.5V208H78V207.5V207H16V207.5ZM78 245.5V245H16V245.5V246H78V245.5ZM16 245.5H16.5V207.5H16H15.5V245.5H16Z"
				fill="#31323A"
				mask="url(#path-102-inside-50_140_23513)"
			/>
			<mask id="path-104-inside-51_140_23513" fill="white">
				<path d="M78 207.5H140V245.5H78V207.5Z" />
			</mask>
			<path d="M78 207.5H140V245.5H78V207.5Z" fill="white" />
			<path
				d="M78 207.5V207H77.5V207.5H78ZM78 245.5H77.5V246H78V245.5ZM78 207.5V208H140V207.5V207H78V207.5ZM140 245.5V245H78V245.5V246H140V245.5ZM78 245.5H78.5V207.5H78H77.5V245.5H78Z"
				fill="#31323A"
				mask="url(#path-104-inside-51_140_23513)"
			/>
			<mask id="path-106-inside-52_140_23513" fill="white">
				<path d="M140 207.5H202V245.5H140V207.5Z" />
			</mask>
			<path d="M140 207.5H202V245.5H140V207.5Z" fill="white" />
			<path
				d="M140 207.5V207H139.5V207.5H140ZM140 245.5H139.5V246H140V245.5ZM140 207.5V208H202V207.5V207H140V207.5ZM202 245.5V245H140V245.5V246H202V245.5ZM140 245.5H140.5V207.5H140H139.5V245.5H140Z"
				fill="#31323A"
				mask="url(#path-106-inside-52_140_23513)"
			/>
			<mask id="path-108-inside-53_140_23513" fill="white">
				<path d="M202 207.5H264V245.5H202V207.5Z" />
			</mask>
			<path
				d="M202 207.5V207H201.5V207.5H202ZM202 245.5H201.5V246H202V245.5ZM202 207.5V208H264V207.5V207H202V207.5ZM264 245.5V245H202V245.5V246H264V245.5ZM202 245.5H202.5V207.5H202H201.5V245.5H202Z"
				fill="#31323A"
				mask="url(#path-108-inside-53_140_23513)"
			/>
			<rect x="264.25" y="207.75" width="61.5" height="37.5" fill="white" stroke="#31323A" stroke-width="0.5" />
			<g clipPath="url(#clip0_140_23513)">
				<path
					d="M10.1016 35.185L8.43262 35.1985L8.43262 25.3536L10.1016 25.1426L10.1016 28.7796C10.6328 28.2032 11.6006 27.6892 12.9348 27.6785C15.4506 27.6582 16.939 29.3797 16.939 31.4652C16.939 33.5507 15.4506 35.2962 12.9348 35.3165C11.6006 35.3272 10.6258 34.8289 10.1016 34.261L10.1016 35.185ZM10.0192 31.5816C10.0192 32.9251 11.1904 33.9333 12.6998 33.9211C14.2093 33.909 15.3541 33.0364 15.3541 31.4832C15.3541 29.9299 14.1339 29.0712 12.6998 29.0828C11.1851 29.095 10.0192 30.1272 10.0192 31.4707L10.0192 31.5816Z"
					fill="black"
				/>
				<path
					d="M17.3848 32.9975C17.3848 31.7094 18.4402 30.9364 20.1916 30.7074L23.3596 30.3022L23.3596 30.2467C23.3596 29.5481 22.7477 29.0243 21.3837 29.0353C20.2565 29.0444 19.2712 29.5689 18.9924 30.2819L17.6144 29.6776C18.0738 28.4465 19.6709 27.6189 21.4381 27.6047C23.6927 27.5865 24.9725 28.5123 24.9725 30.2615L24.9725 33.3489C24.9725 33.7667 25.1636 33.9472 26.0559 33.7476L26.0559 35.046C24.5026 35.3775 23.7908 34.8008 23.5559 34.0763C22.9055 34.7524 21.7782 35.2348 20.416 35.2457C18.7365 35.2593 17.3848 34.5005 17.3848 32.9923L17.3848 32.9975ZM23.3596 31.6232L20.4703 31.9932C19.4973 32.1102 19.01 32.3568 19.01 32.967C19.01 33.5773 19.5955 33.8984 20.5527 33.8907C21.8063 33.8806 23.3596 33.3064 23.3596 32.2334L23.3596 31.618L23.3596 31.6232Z"
					fill="black"
				/>
				<path
					d="M30.3735 27.5378C32.2775 27.5225 33.6397 28.6175 34.099 29.7857L32.7631 30.5662C32.4738 29.7156 31.5534 28.9533 30.356 28.963C28.8676 28.9749 27.7298 29.8804 27.7298 31.3782C27.7298 32.8759 28.8676 33.763 30.356 33.751C31.5481 33.7414 32.4686 32.9643 32.7631 32.109L34.0815 32.8958C33.6116 34.0611 32.2757 35.1605 30.3718 35.1759C27.991 35.1951 26.1309 33.6585 26.1309 31.391C26.1309 29.1236 27.9927 27.557 30.3735 27.5378Z"
					fill="black"
				/>
				<path
					d="M41.1312 32.326L42.4654 33.026C42.0218 34.1789 40.6438 35.2631 38.6855 35.2789C36.2556 35.2985 34.4727 33.7613 34.4727 31.4938C34.4727 29.2263 36.196 27.6609 38.6855 27.6409C40.5509 27.6258 41.8815 28.5842 42.3847 29.9999C42.5109 30.3629 42.5933 30.7246 42.6039 31.1371L36.054 31.9665C36.2784 33.1417 37.3233 33.8597 38.6803 33.8488C39.8899 33.839 40.7806 33.2164 41.1259 32.3209L41.1312 32.326ZM36.1241 30.716L40.7683 30.1117C40.7683 30.1117 40.763 30.084 40.7139 30.0186C40.7034 30.0082 40.6982 29.9961 40.6859 29.9858C40.2967 29.4672 39.5639 29.038 38.5961 29.0458C37.4425 29.0551 36.4415 29.6352 36.1241 30.716Z"
					fill="black"
				/>
			</g>
			<path
				d="M284 0.496094H326C330.142 0.496094 333.5 3.85396 333.5 7.99609V50.2275C333.5 54.3695 330.142 57.7275 326 57.7275H284C279.858 57.7275 276.5 54.3695 276.5 50.2275V7.99609C276.5 3.85396 279.858 0.496094 284 0.496094Z"
				fill="#FFA1C9"
				fill-opacity="0.5"
			/>
			<path
				d="M284 0.496094H326C330.142 0.496094 333.5 3.85396 333.5 7.99609V50.2275C333.5 54.3695 330.142 57.7275 326 57.7275H284C279.858 57.7275 276.5 54.3695 276.5 50.2275V7.99609C276.5 3.85396 279.858 0.496094 284 0.496094Z"
				stroke="black"
			/>
			<path
				d="M295.118 25.9316V33.1116H293.998L289.098 27.5416V33.1116H287.868V25.9316H289.188L293.888 31.2616V25.9316H295.118ZM299.401 25.9316H300.811L304.461 33.1116H303.101L302.191 31.3116H298.021L297.111 33.1116H295.741L299.401 25.9316ZM300.111 27.1916L298.591 30.1916H301.631L300.111 27.1916ZM310.154 33.1116H309.114L306.344 27.0916V33.1116H305.094V25.9316H307.074L309.654 31.5516L312.234 25.9316H314.174V33.1116H312.924V27.0916L310.154 33.1116ZM315.534 25.9316H322.474V27.0516H316.794V28.8516H321.904V29.9716H316.794V31.9916H322.474V33.1116H315.534V25.9316Z"
				fill="black"
			/>
			<defs>
				<clipPath id="clip0_140_23513">
					<rect width="35.0294" height="10.7654" fill="white" transform="matrix(0.999968 -0.00805761 -4.50909e-10 1 8 24.7954)" />
				</clipPath>
			</defs>
		</svg>
	);
};
